<template>
  <div v-if="!carregando">
    <h2>
      {{ paciente.nome }}
    </h2>
    <Tabs v-model="abaSelecionada">
      <Tab title="Diário">
        <PacienteEvolucaoDiarios
          v-if="!carregandoDiarios"
          :diarios="prontuario.diarios"
          :especialidades="especialidades"
          @selecionar="diarioAberto = $event"
          @salvar="salvarDiario"
          @remover="removerDiario"
          @abrir-modal="abrirModalDiario"
        />
      </Tab>
      <Tab
        v-for="especialidade in especialidades"
        :key="especialidade"
        :title="especialidade"
      >
        <PacienteEvolucaoEspecialidade
          :diarios="prontuario.diarios"
          :paciente="paciente._id"
          :paciente-nome="paciente.nome"
          :especialidade="especialidade"
          :abrir-avaliacao="abrirAvaliacao"
          :guia="abrirGuia"
          @salvar="salvarResposta"
          @selecionarDiario="diarioAberto = $event"
          @removerDiario="removerDiario"
        />
      </Tab>
    </Tabs>
    <dialog id="diarioForm" class="diarioForm">
      <h2 class="text-primary"
        >{{ diarioAberto._id ? 'Atualizar' : 'Novo' }} diário</h2
      >
      <br />
      <SelecionarData
        :valor="diarioAberto.data"
        input-group-class="input-group-sm"
        hide-label
        @atualizar="diarioAberto.data = $event"
      />
      <Editor v-model="diarioAberto.entrada" />
      <div style="display: flex; margin-top: 12px; gap: 12px">
        <div class="form-group form-group-sm">
          <label>Especialidade</label>
          <select
            v-model="diarioAberto.especialidade"
            data-test-id="select-diarioaberto-especialidade"
            class="form-control"
            @change="carregarAgendamentos"
          >
            <option v-for="e in especialidades" :key="e">{{ e }}</option>
          </select>
        </div>
        <div v-if="agendamentos.length" class="form-group form-group-sm">
          <label>Sessão</label>
          <select
            v-model="diarioAberto.agendamento"
            data-test-id="select-diarioaberto-agendamento"
            class="form-control"
          >
            <option v-for="a in agendamentos" :key="a._id" :value="a._id">
              {{ formatarData(a.data, 'DD/MM/YYYY') }} {{ a.hora }}
            </option>
          </select>
        </div>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 12px;
        "
      >
        <button
          data-test-id="button-limpardiarioaberto-3"
          class="btn btn-link"
          @click="limparDiarioAberto"
        >
          Cancelar
        </button>
        <div style="display: flex; gap: 12px">
          <button
            data-test-id="button-salvardiario-4"
            class="btn btn-primary"
            :disabled="
              !diarioAberto.entrada.length ||
              !diarioAberto.agendamento ||
              !diarioAberto.data
            "
            @click="salvarDiario(diarioAberto)"
          >
            {{ diarioAberto._id ? 'Atualizar' : 'Adicionar' }}
          </button>
          <button
            data-test-id="button-salvardiario-5"
            class="btn btn-primary"
            :disabled="
              !diarioAberto.entrada.length ||
              !diarioAberto.agendamento ||
              !diarioAberto.data
            "
            @click="salvarDiario(diarioAberto, true)"
          >
            {{
              diarioAberto._id
                ? 'Atualizar + Voltar agendamentos'
                : 'Adicionar + Voltar agendamentos'
            }}
          </button>
        </div>
      </div>
    </dialog>
  </div>
</template>

<script>
import moment from 'moment'

import Editor from '@/componentes/formulario/Editor'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import AgendamentoServico from '@/servicos/AgendamentoServico'
import EvolucaoServico from '@/servicos/EvolucaoServico'
import GuiaServico from '@/servicos/GuiaServico'
import PacienteServico from '@/servicos/PacienteServico'
import appStore from '@/stores'
import * as formatadores from '@/utils/formatadores'

import PacienteEvolucaoDiarios from './PacienteEvolucaoDiarios.vue'
import PacienteEvolucaoEspecialidade from './PacienteEvolucaoEspecialidade.vue'

const agendamentoServico = new AgendamentoServico()
const pacienteServico = new PacienteServico()
const evolucaoServico = new EvolucaoServico()
const guiaServico = new GuiaServico()

export default {
  components: {
    Editor,
    PacienteEvolucaoDiarios,
    PacienteEvolucaoEspecialidade,
    SelecionarData,
  },
  data() {
    return {
      carregando: false,
      carregandoDiarios: false,
      paciente: null,
      especialidades: [],
      agendamentos: [],
      prontuario: { respostas: {}, diarios: [] },
      diarioAberto: {
        _id: null,
        entrada: `
          <h3>Como o paciente chegou (EVA)?</h3>
          <p>(Adicionar aqui a resposta)</p>
          <h3>O que foi realizado?</h3>
          <p>(Adicionar aqui a resposta)</p>
          <h3>Qual o plano de tratamento?</h3>
          <p>(Adicionar aqui a resposta)</p>
        `,
        data: moment.utc().toDate(),
        especialidade: '',
        agendamento: null,
      },
      abaSelecionada: 0,
      abrirAvaliacao: false,
      abrirGuia: null,
    }
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  async created() {
    if (this.usuario.perfil === 'Recepcionista') {
      this.$router.replace({ name: 'Agendamento' })
      return
    }

    this.carregando = true
    await this.carregarPaciente()
    await this.carregarEvolucao()
    const { especialidades } =
      await evolucaoServico.recuperarEspecialidadesComAgendamentos(
        this.$route.params.id
      )

    this.especialidades = especialidades

    const agendamentoId = this.$route.query.agendamento

    if (agendamentoId) {
      const { agendamento } =
        await agendamentoServico.recuperarAgendamento(agendamentoId)
      const agendamentoAvaliacao =
        await this.verificaSePrimeiroAgendamentoDaGuia(agendamento)

      if (agendamentoAvaliacao) {
        const abaEspecialidade =
          this.especialidades.findIndex(
            (e) => e === this.$route.query.especialidade
          ) + 1
        this.abaSelecionada = abaEspecialidade
        this.abrirAvaliacao = true
        this.abrirGuia = agendamento.guia[0]._id
      } else {
        this.abaSelecionada = 0
        this.diarioAberto.especialidade = this.$route.query.especialidade
        await this.carregarAgendamentos()
        this.diarioAberto.agendamento = agendamentoId

        setTimeout(() => {
          document.querySelector('#diarioForm').showModal()
        }, 0)
      }
    }

    this.carregando = false
  },
  methods: {
    ...formatadores,
    async carregarPaciente() {
      const pacienteId = this.$route.params.id
      const { paciente } = await pacienteServico.recuperar(pacienteId)
      this.paciente = paciente
    },
    async carregarEvolucao() {
      const prontuarioFiltro = { paciente_id: this.$route.params.id }
      const {
        prontuarios: [prontuario],
      } = await evolucaoServico.recuperarTodos(prontuarioFiltro)
      this.prontuario = prontuario
    },
    voltarAgendamento({ unidade, especialidade, data }) {
      const formularioCache = JSON.parse(
        window.localStorage.getItem('tu.formularioCache')
      )
      const agendamentosFiltroForm = {
        unidade,
        especialidade,
        dia: moment.utc(data).format('DD/MM/YYYY'),
      }
      window.localStorage.setItem(
        'tu.formularioCache',
        JSON.stringify({ ...formularioCache, agendamentosFiltroForm })
      )
      this.$router.replace({ name: 'Agendamento' })
    },
    async salvarDiario(diario, voltarAgendamento) {
      if (diario._id)
        await evolucaoServico.atualizarDiario(this.prontuario._id, diario)
      else await evolucaoServico.adicionarDiario(this.prontuario._id, diario)
      const { agendamento } = await agendamentoServico.recuperarAgendamento(
        diario.agendamento
      )

      if (agendamento.status === 'assinado') {
        await agendamentoServico.atualizarAgendamentoEvoluido(agendamento)
      }

      await this.carregarEvolucao()
      this.limparDiarioAberto()

      if (voltarAgendamento) {
        this.voltarAgendamento(agendamento)
      }
    },
    async removerDiario(diario) {
      this.$confirm({
        title: 'Remover diário',
        content: 'Você tem certeza que deseja remover o diário?',
        okText: 'Sim',
        cancelText: 'Não',
        cancelType: 'danger',
      }).then(async () => {
        await evolucaoServico.removerDiario(this.prontuario._id, diario)
        await this.carregarEvolucao()
      })
    },
    async salvarResposta({
      resposta,
      prontuarioId,
      questionarioId,
      especialidade,
      avaliacao,
      guias,
      agendamentos,
    }) {
      if (resposta.respostaId) {
        await evolucaoServico.atualizarResposta(
          prontuarioId,
          resposta.respostaId,
          resposta
        )
      } else {
        let _prontuarioId = prontuarioId

        if (!prontuarioId || prontuarioId === '000000000000000000000000') {
          const { prontuario } = await evolucaoServico.adicionarProntuario({
            paciente: this.paciente,
            dataInicio: moment.utc().toISOString(),
            questionario: { _id: questionarioId, avaliacao, especialidade },
            guias,
            agendamentos,
          })

          _prontuarioId = prontuario._id
        }

        await evolucaoServico.adicionarResposta(_prontuarioId, resposta)
      }

      await this.carregarEvolucao()
    },
    async carregarAgendamentos() {
      const { agendamentos } =
        await evolucaoServico.recuperaAgendamentosNaEspecialidade(
          this.$route.params.id,
          this.diarioAberto.especialidade
        )
      this.agendamentos = agendamentos
    },
    limparDiarioAberto() {
      this.diarioAberto = {
        _id: null,
        entrada: '',
        data: moment.utc().toDate(),
        especialidade: '',
        agendamento: '',
      }
      this.agendamentos = []
      document.querySelector('#diarioForm').close()
    },
    async verificaSePrimeiroAgendamentoDaGuia(agendamento) {
      let primeiroDaGuia = true

      // TODO: o que fazer quando o agendamento tem varias guias?
      if (agendamento && agendamento.guia && agendamento.guia[0]._id) {
        const { guia } = await guiaServico.recuperar(agendamento.guia[0]._id)

        for (const a of guia.agendamentos) {
          const { agendamento: _agendamento } =
            await agendamentoServico.recuperarAgendamento(a)

          if (moment(_agendamento.data).isBefore(agendamento.data)) {
            primeiroDaGuia = false
            break
          }
        }
      }

      return primeiroDaGuia
    },
    async abrirModalDiario() {
      const agendamentoId =
        this.diarioAberto.agendamento || this.$route.query.agendamento

      if (agendamentoId) {
        this.abaSelecionada = 0
        this.diarioAberto.especialidade = this.$route.query.especialidade
        await this.carregarAgendamentos()
        this.diarioAberto.agendamento = agendamentoId

        setTimeout(() => {
          document.querySelector('#diarioForm').showModal()
        }, 100)
      }
    },
  },
}
</script>

<style scoped>
.diarioForm {
  padding: 0 12px 10px 12px;
  background-color: #f9f9f9;
  border: 1px solid #ecf0f1;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
</style>
